var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{},[_c('template',{slot:"header"},[_vm._v("Breadcrumb")]),_c('h5',[_vm._v("Breadcrumb with last page active")]),_c('Breadcrumb',{attrs:{"items":[
            {
                page:'Home',
                link:'/'
            },
            {
                page:'Product',
                link: '/product'
            },
            {
                page:'Checkout',
                link: '/checkout',
                active:true,
            } ]}}),_c('h5',{staticClass:"mt-5"},[_vm._v("Breadcrumb with no page active")]),_c('Breadcrumb',{attrs:{"items":[
            {
                page:'Home',
                link:'/'
            },
            {
                page:'First page',
                link: '/first-page'
            },
            {
                page:'Second page',
                link: '/second-page',
            },
            {
                page:'Page without a link',
            },
            {
                page:'Last page',
                link: '/last-page',
            } ]}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }